// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TenantPrivateBenchmarkFromJSON(json) {
    return {
        'fundId': !exists(json, 'fundId') ? undefined : json['fundId'],
        'investorId': !exists(json, 'investorId') ? undefined : json['investorId'],
        'benchmarkId': !exists(json, 'benchmarkId') ? undefined : json['benchmarkId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'isPrivateCustomBenchmark': !exists(json, 'isPrivateCustomBenchmark') ? undefined : json['isPrivateCustomBenchmark'],
        'portfolioId': !exists(json, 'portfolioId') ? undefined : json['portfolioId'],
        'managerId': !exists(json, 'managerId') ? undefined : json['managerId'],
    };
}
export function TenantPrivateBenchmarkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fundId': value.fundId,
        'investorId': value.investorId,
        'benchmarkId': value.benchmarkId,
        'name': value.name,
        'active': value.active,
        'isPrivateCustomBenchmark': value.isPrivateCustomBenchmark,
        'portfolioId': value.portfolioId,
        'managerId': value.managerId,
    };
}
